import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

import { ModelOfDriver, ModelOfDriverForm } from 'src/database/index';

import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';
import { AxiosResponse } from 'axios';
import { dateToString } from 'src/utils/dateToString';

interface DriverCpfProps {
	NOME: string;
	DATANASCIMENTO: string;
}

export const useFormCreateDriver = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(false);
	const [driverCpf, setDriverCpf] = useState<DriverCpfProps[]>([{ NOME: '', DATANASCIMENTO: '' }]);
	const [loadingDriverCpf, setLoadingDriverCpf] = useState(false);
	const [foundDriverCpf, setFoundDriverCpf] = useState(false);
	const [driverResponse, setDriverResponse] = useState<AxiosResponse | null>(null);

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		NOME: Yup.string().required('* Campo obrigatório'),
		DATANASCIMENTO: Yup.string().required('* Campo obrigatório'),
		CPF: Yup.string().required('* Campo obrigatório'),
		CNH: Yup.string().required('* Campo obrigatório'),
		VALIDADECNH: Yup.string().required('* Campo obrigatório'),
		CATEGORIACNH: Yup.string().required('* Campo obrigatório'),
		//LOGIN: Yup.string().email('* Informe um email válido').required('* Campo obrigatório'),
		SENHA: Yup.string().required('* Campo obrigatório'),
		ORGAOUNIDADE: Yup.string().required('* Campo obrigatório'),
	});

	const saveDriver = async (driver: ModelOfDriverForm) => {
		setLoading(true);

		const newDriver: ModelOfDriver = {
			NOME: driver.NOME,
			CPF: driver.CPF,
			CNH: driver.CNH,
			CATEGORIACNH: driver.CATEGORIACNH.join(','),
			ORGAO: userAgencyId,
			DATANASCIMENTO: moment(driver.DATANASCIMENTO, 'DD/MM/YYYY').toDate().toLocaleDateString('en', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
			}),
			VALIDADECNH: moment(driver.VALIDADECNH, 'DD/MM/YYYY').toDate().toLocaleDateString('en', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
			}),
			SENHA: driver.SENHA,
			ORGAOUNIDADE: driver.ORGAOUNIDADE
		};

		api.post('drivers', newDriver)
			.then(() => {
				api.post('register', {
					LOGIN: driver.LOGIN,
					SENHA: driver.SENHA,
					NIVEL: 1,
					ORGAOUNIDADE: driver.ORGAOUNIDADE,
					ORGAO: userAgencyId,
					CPF: driver.CPF,
				})
					.then((response) => {
						setLoading(false);
						setDriverResponse(response);
						toast.current.show([
							{
								severity: 'success',
								summary: 'Cadastro realizado',
								detail: 'Motorista cadastrado com sucesso!',
								life: 5000,
							},
							{
								severity: 'success',
								summary: 'Cadastro realizado',
								detail: 'Usuário de motorista criado com sucesso!',
								life: 5000,
							},
						]);
					})
					.catch((err) => {
						setLoading(false);
						toast.current.show([
							{
								severity: 'success',
								summary: 'Cadastro realizado',
								detail: 'Motorista cadastrado com sucesso!',
								life: 5000,
							},
							{
								severity: 'error',
								summary: 'Cadastro não realizado',
								detail: 'Falha ao criar usuário de motorista!',
								life: 5000,
							},
						]);
					});
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Cadastro não realizado',
					detail: 'Falha ao cadastrar motorista!',
					life: 5000,
				});
			});
	};

	const formik = useFormik<ModelOfDriverForm>({
		initialValues: {
			ORGAO: '',
			NOME: '',
			DATANASCIMENTO: '',
			CPF: '',
			CNH: '',
			VALIDADECNH: '',
			CATEGORIACNH: '',
			LOGIN: '',
			SENHA: '',
			NIVEL: 1,
			ORGAOUNIDADE: '',
		},
		onSubmit: async (values) => await saveDriver(values),
		validationSchema,
	});

	const searchDriverCpf = async (cpf: string) => {
		setLoadingDriverCpf(true);
		const response = await api.post('drivers/get-driver', { CPF: cpf });

		setDriverCpf(response.data);

		setFoundDriverCpf(!!response.data[0]);
		setLoadingDriverCpf(false);
	};

	useEffect(() => {
		if (foundDriverCpf) {
			formik.setFieldValue('NOME', driverCpf[0].NOME);
			formik.setFieldValue('DATANASCIMENTO', dateToString(driverCpf[0].DATANASCIMENTO, 'br'));
		}
	}, [foundDriverCpf]);

	return {
		getDriverFormController: {
			formik,
			loading,
			loadingDriverCpf,
			foundDriverCpf,
			driverCpf,
			toast,
			driverResponse,
		},
		handleDriverFormController: {
			searchDriverCpf,
			setFoundDriverCpf,
		},
	};
};
